import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { UserRoleService } from '../../../../services/user-role.service';
import * as errorUtils from '../../../../modules/utility/global-utils';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-user-count',
  templateUrl: './update-user-count.component.html',
  styleUrls: ['./update-user-count.component.scss']
})
export class UpdateUserCountComponent implements OnInit, OnDestroy {

  updateUserForm: FormGroup;
  userData: any;
  private userSubscription: Subscription;

  constructor(private formBuilder: FormBuilder, public ref: DynamicDialogRef, public config: DynamicDialogConfig, private userRoleService: UserRoleService, private toaster: ToastrService,) {
    this.userData = this.config.data;
    this.createForm();
  }

  ngOnInit(): void {
    if(this.userData){
      this.updateUserForm.controls['users'].setValue(this.userData.count);
    }
  }

  private createForm() {
    this.updateUserForm = this.formBuilder.group({
      users: ['', [Validators.required]]
    });
  }
  
  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  updateUserFormSub(){
    if (this.updateUserForm.valid) {
      this.userSubscription = this.userRoleService.updateUserCount(this.userData.companyId, this.updateUserForm.controls['users'].value).subscribe((user: any) => {
        if(user.status==200){
          this.toaster.success(user.message, 'Success');
          this.ref.close(true);
        }
      });
    }
  }

  closeDialog(){
    this.ref.close();
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

}
